import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { firebaseConfig } from 'src/assets/configs/firebase-config';
import { PipesModule } from './shared/pipes/pipes.module';
import { AuthService } from './auth.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CarouselComponent } from './carousel/carousel.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { GlobalKpiEnvComponent } from './carousel/global-kpi-env/global-kpi-env.component';

import { registerLocaleData } from '@angular/common';
import localeNb from '@angular/common/locales/nb';

registerLocaleData(localeNb);

@NgModule({
  declarations: [
    AppComponent,
    CarouselComponent,
    GlobalKpiEnvComponent,
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AppRoutingModule,
    NgbModule,
    PipesModule,
    FormsModule,
    NoopAnimationsModule,
  ],
  providers: [AuthService],
  bootstrap: [AppComponent],
})
export class AppModule {}
